import { generatePath } from 'react-router-dom';

import { Link, LinkProps } from 'library/components/link/Link';
import { UnitOverviewPageUrl } from 'main/routes/urls/RouteUrls';

interface UnitOverviewLinkProps extends Omit<LinkProps, 'to'> {
	unitPublicId: string;
	onClick?: () => void;
}

export const UnitOverviewLink = ({
	unitPublicId,
	onClick,
	...props
}: UnitOverviewLinkProps): React.JSX.Element => (
	<Link
		className="pc-link"
		onClick={onClick}
		to={generatePath(UnitOverviewPageUrl, {
			unitId: unitPublicId,
		})}
		{...props}
	/>
);
